import { render, staticRenderFns } from "./Loginpage.vue?vue&type=template&id=45e4592c&scoped=true"
import script from "./Loginpage.vue?vue&type=script&lang=js"
export * from "./Loginpage.vue?vue&type=script&lang=js"
import style0 from "./Loginpage.vue?vue&type=style&index=0&id=45e4592c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e4592c",
  null
  
)

export default component.exports